declare var window: any;

const UpdateNotificationBadge = {
  updated(this: any) {
    window.getNotificationBadge();
  },
};

export default UpdateNotificationBadge;
